export default __webpack_public_path__ + "static/media/Menu_Pullover.38f04a79.svg";